module.exports = __webpack_public_path__ + "static/img/case-glj-page-bg-08.b52b9d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/glj/case-glj-page-bg-08.jpg
// module id = glwx
// module chunks = 1